"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ValidationResult_1 = require("../../../core/model/errors/ValidationResult");

var ProgressMonitorKind_1 = require("../../../core/model/ProgressMonitorKind");

var PriceTermination_1 = require("../../../price-termination/model/PriceTermination"); // tslint:disable:max-classes-per-file

/**
 * <p>Distinguishes monitors related to asynchronous process of terminating {@link SelloutTermination}.</p>
 *
 * <p><b>It can also be used as monitor for terminating process of a specific release represented as {@link SelloutTerminationSummaryItem},
 * which is only possible if the previous export failed.</b></p>
 *
 * @author JMe
 */


var SelloutTerminationMonitor =
/*#__PURE__*/
function (_ProgressMonitorKind_) {
  _inherits(SelloutTerminationMonitor, _ProgressMonitorKind_);

  function SelloutTerminationMonitor() {
    _classCallCheck(this, SelloutTerminationMonitor);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationMonitor).apply(this, arguments));
  }

  _createClass(SelloutTerminationMonitor, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }]);

  return SelloutTerminationMonitor;
}(ProgressMonitorKind_1.ProgressMonitorKind);

exports.SelloutTerminationMonitor = SelloutTerminationMonitor;
SelloutTerminationMonitor.TAG = ProgressMonitorKind_1.ProgressMonitorKind.register(SelloutTerminationMonitor);
/**
 * <p>Entity that represents the entire termination process. Instances of this object are created after a successful upload, which
 * already included basic validations (if the validations failed, no instance is created). The initial state of created instance is
 * {@link PriceTerminationState.Opened}.</p>
 *
 * @author JMe
 */

var SelloutTermination =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutTermination, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Identification of termination record.
   * @param name The name of the record entered by user.
   * @param state The overall state of termination record.
   * @param terminationIssued The moment the user confirmed termination of selected records and termination has begun.
   * @param progressId Identification of progress related to this termination process. Most probably this will be only in use for
   *        processing of confirmation of the entire termination. If there is no termination process in run, there will be no reference.
   * @param validation Validation result aggregated to entire process.
   *        May aggregate summary info in case of errors within some {@link SelloutTerminationItem items}.
   */
  function SelloutTermination(id, name, state, terminationIssued, progressId, validation) {
    var _this;

    _classCallCheck(this, SelloutTermination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTermination).call(this));
    _this.id = id;
    _this.name = name;
    _this.state = state;
    _this.terminationIssued = terminationIssued;
    _this.progressId = progressId;
    _this.validation = validation;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutTermination, [{
    key: "isEditable",
    value: function isEditable() {
      return this.state === PriceTermination_1.PriceTerminationState.Opened;
    }
  }]);

  return SelloutTermination;
}(DomainObject_1.DomainObject);

exports.SelloutTermination = SelloutTermination;

SelloutTermination.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutTermination.name);
  return {
    id: builder.id('id'),
    name: builder.str('name'),
    // TODO: add sequence
    state: builder.senum('state', PriceTermination_1.PriceTerminationState, CodebookLookupSequence_1.CodebookLookupSequence.PriceTerminationStates),
    terminationIssued: builder.opt(builder.date('terminationIssued')),
    progressId: builder.opt(builder.str('progressId')),
    validation: builder.obj('validation', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();